"use client";
import { jsx } from "react/jsx-runtime";
import { Toaster } from "sonner";
const Toaster_Toaster = ({ ...props })=>/*#__PURE__*/ jsx(Toaster, {
        className: "toaster group tw-pointer-events-auto",
        position: "top-right",
        ...props
    });
export { Toaster_Toaster as Toaster };
